import { cn } from '@latitude/token-utils';

type CircularProgressCircleProps = {
  circProgressSize: number;
  progressPercentage: number;
};

export const CircularProgressCircle = ({
  circProgressSize,
  progressPercentage,
}: CircularProgressCircleProps) => {
  const strokeWidth: number = 2;
  const radius: number = (circProgressSize - strokeWidth) / 2;
  const dashArray: number = radius * Math.PI * 2;
  const dashOffset: number = dashArray - (dashArray * progressPercentage) / 100;

  return (
    <>
      <circle
        className={cn([
          'fill-none',
          'stroke-color-comp-circular-progress-container',
        ])}
        cx={circProgressSize / 2}
        cy={circProgressSize / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
      />
      <circle
        className={cn([
          'fill-none',
          'stroke-color-comp-circular-progress-on-container',
        ])}
        cx={circProgressSize / 2}
        cy={circProgressSize / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
        strokeDasharray={dashArray}
        strokeDashoffset={dashOffset}
        strokeLinecap="round"
        transform={`rotate(-90 ${circProgressSize / 2} ${circProgressSize / 2})`}
      />
    </>
  );
};
